import React from "react";
import {t} from "../../shared-services/translate";
import {FarmyButton} from "../../react-components/shared/SharedComponents";

import {useCartActions} from "../../shared-services/redux-tiny";
import useFullLoader from "../loaders/useFullLoader";
import apiEndpoints from "../shared/apiEndpoints";

const UnavailableCTA = (props) => {
  const {order, onRemove, children} = props;
  const {removeUnavailableProducts} = apiEndpoints.orders;
  const {requestCartLoad} = useCartActions();
  const {launchLoader} = useFullLoader();

  const onRemoveClick = () => {
    const duration = 1000;
    launchLoader({duration});

    removeUnavailableProducts(order?.number).then(result => {
      requestCartLoad();
      if (onRemove) onRemove();
    });
  };

  return <FarmyButton onClick={onRemoveClick} className="margin-top-20">
    {children || t("cart.unavailable.remove_items_and_continue")}
  </FarmyButton>;
};

export default UnavailableCTA;
